import { useEffect, useReducer } from 'react';

const useFetchByTab = ({
    key = '',
    asyncFn = () => {},
    adapter = null,
    enabled = true,
}) => {
    const initialState = {
        data: null,
        loading: false,
        isError: false,
        error: null,
    };

    const [state, dispatch] = useReducer(
        (prev, next) => ({
            ...prev,
            ...next,
        }),
        initialState
    );

    const fetchData = async () => {
        dispatch({ ...initialState, loading: true });

        try {
            const response = await asyncFn();

            if (response === null) {
                dispatch({ ...initialState });
                return;
            }

            if (response?.error) {
                dispatch({
                    data: null,
                    loading: false,
                    isError: true,
                    error: response.error,
                });
            } else {
                dispatch({
                    data: adapter ? adapter(response) : response,
                    loading: false,
                    isError: false,
                    error: null,
                });
            }
        } catch (err) {
            dispatch({
                data: null,
                loading: false,
                isError: true,
                error: err.message || 'Error inesperado',
            });
        }
    };

    useEffect(() => {
        if (!enabled) return;
        fetchData();
    }, [key, enabled]);

    const refetch = async () => {
        if (!enabled) return;
        await fetchData();
    };

    return {
        data: state.data,
        loading: state.loading,
        isError: state.isError,
        error: state.error,
        refetch,
    };
};

export default useFetchByTab;
